import { ButtonProps } from "fe-shared/src/components";
import { CloseIcon, CheckIcon } from "fe-shared/src/components/Icons";
import { Transfer, TransferStatus, TransferType } from "../../../types";

import styles from "../TransferDetails.module.scss";

export enum TransferAction {
  Cancel = "Cancel",
  Invalidate = "Invalidate",
}

export type ActionPermissions = { [key in TransferAction]?: boolean };

export interface ActionConfig {
  name: TransferAction;
  isVisible: (
    transfer: Transfer,
    permissions: ActionPermissions,
    isStaffView?: boolean
  ) => boolean;
  isDisabled?: (transfer: Transfer) => boolean;
  hasConfirmationDialog: boolean;
  buttonProps: Partial<ButtonProps>;
  dialogButtonProps?: Partial<ButtonProps>;
}

const {
  IntoProcessing,
  OutOfProcessing,
  NonEligibleWriteOff,
  NonEligibleBufferWriteOff,
} = TransferType;

const CancelActionVisibleMap: TransferType[] = [
  IntoProcessing,
  OutOfProcessing,
  NonEligibleWriteOff,
  NonEligibleBufferWriteOff,
];

const WriteOffTypeMap: TransferType[] = [
  TransferType.NonEligibleWriteOff,
  TransferType.NonEligibleBufferWriteOff,
];

export const actions: ActionConfig[] = [
  {
    name: TransferAction.Cancel,
    isVisible: (t, permissions, isStaffView) =>
      !!permissions[TransferAction.Cancel] &&
      t.statusCode === TransferStatus.Submitted &&
      (!isStaffView || WriteOffTypeMap.includes(t.transferType)) &&
      CancelActionVisibleMap.includes(t.transferType) &&
      t.isAdjustable,
    hasConfirmationDialog: true,
    buttonProps: {
      variant: "filled",
      iconComponent: CloseIcon,
      className: styles.cancel,
    },
    dialogButtonProps: {
      variant: "filled",
      iconComponent: CheckIcon,
    },
  },
  {
    name: TransferAction.Invalidate,
    isVisible: (t, permissions, isStaffView) =>
      !!permissions[TransferAction.Invalidate] &&
      !!isStaffView &&
      !WriteOffTypeMap.includes(t.transferType) &&
      t.statusCode === TransferStatus.Approved,
    hasConfirmationDialog: true,
    buttonProps: {
      variant: "filled",
      iconComponent: CloseIcon,
      className: styles.cancel,
    },
    dialogButtonProps: {
      variant: "filled",
      iconComponent: CheckIcon,
    },
  },
];
